import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { csv } from 'd3-fetch'
import Text from '../atoms/Text'
import Bullets from '../atoms/Bullets'
import Link from '../molecules/Link'
import Quote from '../molecules/Quote'
import Hero from '../organisms/Hero'
import Demographics from '../organisms/Demographics'
import TechUse from '../organisms/TechUse'
import Cards from '../organisms/Cards'
import PerfVsPot from '../organisms/PerfVsPot'
import Challenges from '../organisms/Challenges'
import Constraints from '../organisms/Constraints'
import Optimism from '../organisms/Optimism'

const Container = styled.div`
  padding: 0 1rem;
`
const Main = () => {
  //const $ = window.WILDLABS_VARS
  const [text, setText] = useState(null)
  const [notes, setNotes] = useState(null)
  const [links, setLinks] = useState(null)
  const [quotes, setQuotes] = useState(null)

  useEffect(() => {
    Promise.all([
      csv('./data/text.csv'),
      csv('./data/chartNotes.csv'),
      csv('./data/links.csv'),
      csv('./data/quotes.csv')
    ]).then((data) => {
      setText(data[0][0])
      setNotes(data[1][0])
      setLinks(data[2])
      setQuotes(data[3])
    })
  }, [])

  return (
    <>
      <Hero text={text?.intro_one} />
      <Container>
        <Text text={text?.intro_two} />
        <Text text={text?.about} />
        <Link link={links ? links[0] : null} />
        <Text text={text?.what} />
        <Link link={links ? links[1] : null} />
        <Text text={text?.who_one} />
        <Demographics />
        <Text text={text?.who_two} />
        <Text text={text?.current_tools_one} />
        <TechUse note={notes?.tech_use_note} />
        <Text text={text?.current_tools_two} />
        <Text text={text?.sw_one} />
        <Cards note={notes?.sw_note} />
        <Text text={text?.sw_two} />
        <Quote quote={quotes ? quotes[0] : null} />
        <Text text={text?.sw_three} />
        <Quote quote={quotes ? quotes[1] : null} />
        <Text text={text?.perf} />
        <PerfVsPot note={notes?.perf_note} />
        <Quote quote={quotes ? quotes[2] : null} />
        <Text text={text?.constraints_one} top={true} />
        <Challenges />
        <Text text={text?.constraints_two} />
        <Quote quote={quotes ? quotes[3] : null} />
        <Text text={text?.constraints_three} />
        <Constraints note={notes?.constraints_note} />
        <Quote quote={quotes ? quotes[4] : null} />
        <Text text={text?.constraints_four} />
        <Bullets text={text?.constraints_bullets} />
        <Link link={links ? links[2] : null} />
        <Quote quote={quotes ? quotes[5] : null} />
        <Text text={text?.opp_one} />
        <Quote quote={quotes ? quotes[6] : null} />
        <Optimism />
        <Text text={text?.opp_two} />
        <Bullets text={text?.opp_bullets} />
        <Text text={text?.opp_three} />
        <Quote quote={quotes ? quotes[7] : null} />
        <Text text={text?.opp_four} />
        <Quote quote={quotes ? quotes[8] : null} />
        <Text text={text?.opp_five} />
        <Quote quote={quotes ? quotes[9] : null} />
        <Text text={text?.next_one} />
        <Quote quote={quotes ? quotes[10] : null} />
        <Text text={text?.next_two} />
        <Link link={links ? links[3] : null} />
        <Text text={text?.next_three} />
        <Text text={text?.acknowledgments} />
      </Container>
    </>
  )
}

export default Main
